import {sliderAnatomy as parts} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system'

import borders from '../foundations/borders'
import colors from '../foundations/colors'
import opacity from '../foundations/opacity'
import sizes from '../foundations/sizes'
import spacing from '../foundations/space'
import typography from '../foundations/typography'

const {definePartsStyle, defineMultiStyleConfig} =
  createMultiStyleConfigHelpers(parts.keys)

const baseStyle = definePartsStyle({
  container: {
    spacing: spacing['6xs'],
    paddingY: spacing['6xs'],
  },
  track: {
    borderRadius: borders.radii.full,
    _disabled: {
      opactiy: opacity.disabled,
    },
    _readOnly: {
      cursor: 'default',
    },
  },
  filledTrack: {
    bg: colors.background.brand,
    _readOnly: {
      cursor: 'default',
    },
  },
  thumb: {
    bg: colors.background.primary,
    borderColor: colors.border.primary,
    _hover: {
      borderColor: colors.border.secondary,
      bg: colors.background.primary,
    },
    _focus: {
      boxShadow: 'None',
      borderColor: colors.border.brand,
      bg: colors.background.primary,
    },
    _active: {
      bg: colors.background.brand,
    },
    _readOnly: {
      cursor: 'default',
    },
  },
  mark: {
    height: sizes['6xs'],
    color: colors.text.secondary,
    itemSpacing: spacing['6xs'],
    paddingTop: spacing['6xs'],
    paddingBottom: spacing['6xs'],
    marginLeft: -3, // This matches the labels with the slider value.
    ...typography.textStyles.caption.medium,
  },
})

const sliderTheme = defineMultiStyleConfig({
  baseStyle,
})

export default sliderTheme
